import { render } from "./AncillaryInfo.vue?vue&type=template&id=f2a2219a"
import script from "./AncillaryInfo.vue?vue&type=script&lang=ts"
export * from "./AncillaryInfo.vue?vue&type=script&lang=ts"
script.render = render

export default script